import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/xuxun/Documents/projects/xx/antd-utils/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { HandleVisibilityChange } from './handle-visibility-change.tsx';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "handle-visibility-change"
    }}>{`Handle Visibility Change`}</h1>
    <p>{`页面进入或离开触发回调函数`}</p>
    <HandleVisibilityChange mdxType="HandleVisibilityChange" />
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import React, { FC, useEffect, useState } from 'react'
import 'antd/dist/antd.css'
import { handleVisibilityChange } from 'antd-utils'
import { Card } from 'antd'

/*
 * 页面离开后，再次进入时触发回调函数
 * 应用场景：列表页新开页面编辑新增，返回后自动刷新列表
 * handlePageshow(() => setSearch({ ...(search || {}) }))
 * @param callback () => void
 */

export const HandleVisibilityChange: FC = () => {
  useEffect(() => {
    handleVisibilityChange(() => document.title = '咦，我又好了(⊙o⊙)…', () => document.title = '页面又崩溃啦ε=(´ο｀*)))唉')
  }, []);
  return (
    <Card>
      切换下 tab 看看 title~
    </Card>
  )
}
`}</code></pre>
    <h2 {...{
      "id": "应用场景"
    }}>{`应用场景`}</h2>
    <ul>
      <li parentName="ul">{`列表页新开页面编辑新增，返回后自动刷新列表`}</li>
      <li parentName="ul">{`有趣的标题`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      